import script from "./vipHistoryPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./vipHistoryPopup.vue?vue&type=script&setup=true&lang=ts"

import "./vipHistoryPopup.vue?vue&type=style&index=0&id=2dc1f654&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc1f654"]])

export default __exports__